import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import config from 'config';
import {sendSystemNotificationRequested} from 'services/systemNotifications/actions';
import {confirmActionRequested} from 'services/confirmAction/action';
import {
    fetchCompanyRequested,
    fetchMembersRequested,
    removeMembersRequested,
    updateMemberRequested,
} from 'services/company/action';

import Employees from './Employees';


class Index extends React.Component {

    componentDidMount() {
        const {fetchCompany} = this.props;
        fetchCompany();
        const {user} = this.props;
        this.setState({...user});
    }

    render() {
        const {
            user, company, addNotification,
            company: {members}, sendSystemNotification,
            updateMember, removeMembers,
            confirmAction, commonStyles,
        } = this.props;
        const {roles, statuses, statusMap} = config;

        const membersToShow = members.filter(member => member.status !== statusMap.deleted);

        return (
            <Employees
                members={membersToShow}
                roles={roles}
                statuses={statuses}
                sendSystemNotification={sendSystemNotification}
                updateMember={updateMember}
                removeMembers={removeMembers}
                confirmAction={confirmAction}
                addNotification={addNotification}
                user={user}
                company={company}
                commonStyles={commonStyles}
                fetchCompany={this.props.fetchCompany}
            />
        );
    }
}

Index.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
    fetchMembers: PropTypes.func.isRequired,
    confirmAction: PropTypes.func.isRequired,
    sendSystemNotification: PropTypes.func.isRequired,
    updateMember: PropTypes.func.isRequired,
    removeMembers: PropTypes.func.isRequired,
    commonStyles: PropTypes.shape({
        wrapper: PropTypes.object.isRequired,
        title: PropTypes.object.isRequired,
    }).isRequired,
};

const mapDispatchToProps = dispatch => ({
    fetchMembers: () => {
        dispatch(fetchMembersRequested());
    },
    sendSystemNotification: (receiversIdList, text) => {
        dispatch(sendSystemNotificationRequested(receiversIdList, text));
    },
    updateMember: (memberInfo) => {
        dispatch(updateMemberRequested(memberInfo));
    },
    removeMembers: (membersList) => {
        dispatch(removeMembersRequested(membersList));
    },
    confirmAction: (actionFunc, actionFuncArgs) => {
        dispatch(confirmActionRequested(actionFunc, actionFuncArgs));
    },
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
});

export default connect(null, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/index.jsx